import { Chip, Tooltip } from '@mui/material';
import type { TurnKind } from '../../types';

// A plain user message needs no badge; every other kind says who wrote the turn.
const TURN_KINDS: Record<Exclude<TurnKind, 'user_message'>, { label: string; tooltip: string; color: string }> = {
  task_follow_up: {
    label: 'Automated follow-up',
    tooltip: 'Written by the platform when a tracked task finished — no person sent this turn',
    color: '#94a3b8',
  },
  research_run: {
    label: 'Unattended research run',
    tooltip: "A person's research request, run by the platform with nobody watching",
    color: '#14b8a6',
  },
  form_submission: {
    label: 'Card answer',
    tooltip: 'The person answered a card shown under an earlier reply',
    color: '#38bdf8',
  },
};

export function isAutomatedTurn(kind: TurnKind | null | undefined): boolean {
  return kind === 'task_follow_up';
}

export default function TurnKindChip({ kind }: { kind: TurnKind | null | undefined }) {
  if (!kind || kind === 'user_message') return null;
  const { label, tooltip, color } = TURN_KINDS[kind];
  return (
    <Tooltip title={tooltip} arrow>
      <Chip
        label={label}
        size="small"
        sx={{ height: 20, fontSize: '0.65rem', bgcolor: `${color}25`, color, fontWeight: 500 }}
      />
    </Tooltip>
  );
}
